import React, { Component } from "react";
import './styles.css';

class Nieto extends Component{

    StyleCompleted(){
        return{ 
            background: this.props.nieto.state ? 'rgba(80, 255, 130, 1)' : 'rgba(255, 0, 0, 0.7)',
            textDecoration: 'none',
            display: 'flex',
            justifyContent: 'center',            
            width: 'auto'
        }
    }      

    render(){

        const{nieto} = this.props;        

        return(
                <div className="r-d" style={this.StyleCompleted()}>                    
                    <div className="r-d-user">  {nieto.user}  </div>
                    <div className="r-d-pass">  {nieto.pass}  </div>                    
                    <div className="r-d-desciption"> {nieto.description} </div>  
                    <div className="r-d-enable">
                        <input 
                            style={inputEnable} 
                            type="checkbox" 
                            onChange={this.props.chechState.bind(this, nieto.id)} 
                            checked={nieto.state}
                        />
                    </div> 
                    <div className="r-d-delete">                         
                        <button className="btnDelete" onClick={this.props.deleteNieto.bind(this, nieto.id)} > 
                            Delete                
                        </button>                                                
                    </div> 
                    <br />            
                </div>
        )
    }
}

const inputEnable ={
    width: '20px',
    height: '20px',
    margin: 'auto'
}

export default Nieto;